import React, { useContext, useState } from 'react';
import { ThemeContext } from '../../store/ThemeProvider';
import ReactSVG from 'react-svg';
import './GorgeousHeader.scss';
import { alpha } from '../../utils/color';

export interface IHeader {
  title: string;
  subTitle?: string;
  simple?: boolean;
}
export const Header = function(props: IHeader) {
  return (
    <div className="head">
      {props.title}
      {props.subTitle ? (
        <span className="subTitle">{props.subTitle}</span>
      ) : null}
    </div>
  );
};

const GorgeousHeader = function(props: IHeader) {
  const { simple } = props;
  const { h1Color, mainColor } = useContext(ThemeContext);
  // const newMainColor = alpha(mainColor, h1Color, 0.6);
  const newMainColor = alpha(h1Color, 0.6);
  return (
    <div className="gorgeous-header">
      {!simple ? (
        <ReactSVG
          src={require('../../svg/dots-8-lighter.svg')}
          className={'bg bg-lt rotate'}
          style={{ color: mainColor }}
        />
      ) : null}
      {!simple ? (
        <ReactSVG
          src={require('../../svg/dots-8-lighter.svg')}
          className={'bg bg-rb'}
          style={{ color: mainColor }}
        />
      ) : null}
      <div className="main-head" style={{ color: newMainColor }}>
        {!simple ? (
          <ReactSVG
            src={require('../../svg/dots-8.svg')}
            className={'bg'}
            style={{ color: mainColor }}
          />
        ) : null}
        <div className="head-title" style={{ color: h1Color }}>
          {props.title}
        </div>
        {!simple ? (
          <ReactSVG
            src={require('../../svg/dots-8.svg')}
            className={'bg rotate'}
            style={{ color: mainColor }}
          />
        ) : null}
      </div>
    </div>
  );
};

export default GorgeousHeader;
